import React from 'react';

export const replaceContentfulDelimiter = (string, delimiter, replace) => {
  const start = string.split(delimiter)[0];
  const end = string.split(delimiter)[1];
  return start && end ? (
    <>
      {start}
      {replace}
      {end}
    </>
  ) : (
    string
  );
};
